// src/components/LanguageSwitcher.js
import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSwitcher.css';

const LANGUAGES = [
  { code: 'fr', label: 'FR', flag: '🇫🇷' },
  { code: 'en', label: 'EN', flag: '🇬🇧' },
];

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const current =
    LANGUAGES.find((l) => l.code === i18n.language) || LANGUAGES[0];
  const others = LANGUAGES.filter((l) => l.code !== current.code);

  useEffect(() => {
    const onClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onClickOutside);
    return () => document.removeEventListener('mousedown', onClickOutside);
  }, []);

  const changeLanguage = (lng) => {
    if (i18n && i18n.changeLanguage) {
      i18n.changeLanguage(lng);
    } else {
      console.error("⚠️ i18n n'est pas bien initialisé !");
    }
    setOpen(false);
  };

  return (
    <div className="language-switcher" ref={ref}>
      {open &&
        others.map((lang) => (
          <button
            key={lang.code}
            type="button"
            className="language-switcher-option"
            onClick={() => changeLanguage(lang.code)}
          >
            <span className="language-switcher-flag" aria-hidden="true">
              {lang.flag}
            </span>
            {lang.label}
          </button>
        ))}

      <button
        type="button"
        className="language-switcher-trigger"
        onClick={() => setOpen((o) => !o)}
        aria-haspopup="true"
        aria-expanded={open}
      >
        <span className="language-switcher-flag" aria-hidden="true">
          {current.flag}
        </span>
        {current.label}
        <span className="language-switcher-arrow" aria-hidden="true">
          ▾
        </span>
      </button>
    </div>
  );
}
